import { render, staticRenderFns } from "./ChildrensAdventurers.vue?vue&type=template&id=2f56caee&"
import script from "./ChildrensAdventurers.vue?vue&type=script&lang=js&"
export * from "./ChildrensAdventurers.vue?vue&type=script&lang=js&"
import style0 from "./ChildrensAdventurers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports